module.exports = __webpack_public_path__ + "static/media/cafe24-main-md.6e4d243a.png";